import { render } from "./GradioAppBotSettings.vue?vue&type=template&id=10028b64"
import script from "./GradioAppBotSettings.vue?vue&type=script&lang=js"
export * from "./GradioAppBotSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__